export const MIN_COURSE_LENGTH_2020 = {
  9: 1500,
  18: 3000,
}

export const MIN_COURSE_LENGTH_2024 = {
  9: 750,
  18: 1500,
}
export const getMinCourseLength = (manualVersion?: string, holes?: number) => {
  if (!manualVersion || !holes) return undefined

  // uses startsWith to handle manual revisions like 2024_1 etc
  if (manualVersion.startsWith('2020')) {
    return MIN_COURSE_LENGTH_2020[holes]
  }

  if (manualVersion.startsWith('2024')) {
    return MIN_COURSE_LENGTH_2024[holes]
  }

  return undefined
}
